import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContractCheckGrid from "./ContractCheckGrid";
import moment from 'moment'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as RemittanceLogCheck from './Saga/RemittanceLogCheck';
import { makeStyles, withStyles } from '@material-ui/core/styles';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_owner_remittance_check_logs: any,
    get_so_ymd_list: any,
    search_detail: any,
    classes: any,
    search_loading: boolean,
}



interface State {

    // state types
}


const styles = ((theme: any) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))



class CustomerList extends Component<Props, State> {
    componentWillMount() {
        // this.props.get_owner_remittance_check_logs()
        this.props.get_so_ymd_list()

        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_owner_remittance_check_logs(state)
    }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {/* {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse} */}
                    <div className="item">
                        <Search />

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-12"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <ContractCheckGrid />
                    </div>
                </div>
                <Backdrop className={this.props.classes.backdrop} open={this.props.search_loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        search_loading: state.ContractCheck.search_loading,
        owner_remittance_check_logs: state.RemittanceLogCheck.owner_remittance_check_logs,
    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        get_so_ymd_list(state: any) {
            dispatch(RemittanceLogCheck.get_so_ymd_list(state))
        },
        get_owner_remittance_check_logs(state: any) {
            dispatch(RemittanceLogCheck.get_owner_remittance_check_logs(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomerList));




